export function cleanChoiceDescription(description: string): string {
	return description.replace(/^- /, '');
}

export function alignChoiceItems(container: Element): void {
	container.querySelectorAll('.cog-choice-option').forEach((item: Element) => {
		const inputContainer = item.querySelector('.el-radio__input, .el-checkbox__input, .cog-choice-image-container');
		const labelContainer = item.querySelector('.el-radio__label, .el-checkbox__label, .cog-choice__readonly-label');

		if (!inputContainer || !labelContainer) return;
		if (getComputedStyle(inputContainer as HTMLElement).position === 'absolute') return;

		// Center align unless the label is taller than either input or image.
		const firstChar = (labelContainer as HTMLElement).innerText.trim().charAt(0);
		const isUpperCase = firstChar !== '' && firstChar === firstChar.toUpperCase();
		const inputContainerHeight = (inputContainer as HTMLElement).clientHeight;

		// Calculate label content height without padding to prevent ResizeObserver loop in Firefox.
		// Using offsetHeight would include padding that changes based on data-align-top, causing an infinite loop.
		const labelStyle = getComputedStyle(labelContainer as HTMLElement);
		const currentPaddingTop = parseFloat(labelStyle.paddingTop) || 0;
		const currentPaddingBottom = parseFloat(labelStyle.paddingBottom) || 0;
		const labelContentHeight = (labelContainer as HTMLElement).scrollHeight - currentPaddingTop - currentPaddingBottom;

		const labelIsTaller = labelContentHeight > inputContainerHeight + 5;

		// Only update attributes if they've changed to prevent unnecessary DOM mutations
		const currentAlignTop = (item as HTMLElement).getAttribute('data-align-top');
		const newAlignTop = labelIsTaller.toString();
		if (currentAlignTop !== newAlignTop)
			(item as HTMLElement).setAttribute('data-align-top', labelIsTaller.toString());

		const currentUppercase = (item as HTMLElement).getAttribute('data-uppercase');
		const newUppercase = isUpperCase.toString();
		if (currentUppercase !== newUppercase)
			(item as HTMLElement).setAttribute('data-uppercase', newUppercase);
	});
}
export function constrainCardDimensions(items) {
	let maxAspectRatio = 0;
	let minPortraitAspectRatio = Infinity;
	let allPortrait = true;

	items.forEach((item) => {
		const dimensions = item.choiceImageDimensions || item;
		const currentHeight = dimensions.height;
		const currentWidth = dimensions.width;
		const currentAspectRatio = currentHeight / currentWidth;
		if (currentAspectRatio > maxAspectRatio)
			maxAspectRatio = currentAspectRatio;

		// Get the fattest portrait aspect ratio
		if (currentAspectRatio > 1 && currentAspectRatio < minPortraitAspectRatio)
			minPortraitAspectRatio = currentAspectRatio;

		if (currentAspectRatio <= 1)
			allPortrait = false;
	});

	const isLandscape = maxAspectRatio < 1;

	if (Number.isFinite(minPortraitAspectRatio) && allPortrait)
		return { maxWidth: `calc(var(--image-size) / ${minPortraitAspectRatio})` };

	if (!isLandscape || maxAspectRatio === 0)
		return null;

	return { maxHeight: `calc(var(--image-size) * ${maxAspectRatio})` };
}